import $ from "jquery";

import FilePreviewComponent from "@/components/FilePreviewComponent/FilePreviewComponent.vue";
import Navbar from '@/components/Home_Navbar/NavbarView.vue';
import Sidebar from '@/components/Home_Sidebar/sidebarView.vue';
import PoweredBy from '@/components/PoweredBy/PoweredByView.vue';
import { get_token, get_drive_id } from '@/router/index.js';

export default {
  name: 'DriveView',
  components: { Sidebar, Navbar,PoweredBy, FilePreviewComponent},
  data: () => ({
    dataTable: null,
    uploads: [],
    drive_items: [],
    active_tab: 'folder',      // default active tab on modal open
    current_folder: "My Drive", // default folder context
    open_dropdown_id: null,    // track which dropdown is open
    open_submenu_id: null,     // track which file's submenu is open
    open_menu_name: null,     // track which submenu type is open ('share', etc.)
    preview_file_name: "",
    preview_file_url: "",
    preview_file_access_level: null,
    preview_modal: false,
    share_link: "",
    share_modal: false,
    share_file: null,
    access_levels: [],
    share_mode: 'restricted', 
    selected_access_level: '',
    drive_id: null,
    share_user_modal: false,
    share_success: false,
    available_users: [],
    filtered_available_users: [],
    selected_share_users: [],
    user_search_query: '',
    loading_users: false,
    users_error: null,
    sharing_in_progress: false,
    share_error: null,
    user_access_level: '',

    // UI filters
    list_search_query: "",
    fileTypeFilter: "all",

    // misc
    drag_over: false,
    submenu_open: {},
    selected_url: null,
    uploading_in_progress: false,

    // Drag and drop
    dragged_item: null,
    drag_over_folder_id: null,
  }),
  computed: {
    breadcrumb_path() {
      let path = [];
      let folder = this.current_folder;

      while (folder && folder !== "My Drive") {
        const folderItem = this.drive_items.find(
          item => item.name === folder && item.type === "folder"
        );
        if (!folderItem) break;
        path.unshift(folderItem);
        folder = folderItem.parent_id;
      }

      return path; // array of folder objects from root to current
    },
    // Cards at the top (3 most recent files)
    for_you_items() {
      return this.drive_items
        .filter((i) => i.type !== "folder")
        .sort((a, b) => {
        const a_time = a.updated_ts || new Date(a.updated_at).getTime();
        const b_time = b.updated_ts || new Date(b.updated_at).getTime();
        return b_time - a_time;
      })
      .slice(0, 3);
    },
    filtered_items() {``
      const my_item = this.drive_items.find(i => !i.shared_access_level);
      const current_user_name = my_item ? my_item.owner : "";

      const in_folder = this.drive_items.filter((i) => {
        const is_in_current = i.parent_id === this.current_folder;

        const is_owned_orphan = this.current_folder === "My Drive" &&
                                i.owner === current_user_name &&
                                !this.drive_items.some(f => f.name === i.parent_id && f.type === 'folder');

        const is_shared_orphan = this.current_folder === "My Drive" &&
                                i.shared_access_level !== null &&
                                !this.drive_items.some(f => f.name === i.parent_id && f.type === 'folder');

        return is_in_current || is_owned_orphan || is_shared_orphan;
      });

      const q = (this.list_search_query || "").toLowerCase().trim();
      const by_query = !q
        ? in_folder
        : in_folder.filter(
            (i) =>
              i.name.toLowerCase().includes(q) ||
              (i.owner || "").toLowerCase().includes(q)
          );

      const type = this.fileTypeFilter;
      if (type === "all") return by_query;

      return by_query.filter((i) => this.matches_chip(i, type));
    },
    chip_options() {
      return [
        { value: "all", label: "All", icon: "far fa-circle" },
        { value: "word", label: "Word", icon: "far fa-file-word" },
        { value: "excel", label: "Excel", icon: "far fa-file-excel" },
        { value: "ppt", label: "PowerPoint", icon: "far fa-file-powerpoint" },
        { value: "pdf", label: "PDF", icon: "far fa-file-pdf" },
        { value: "image", label: "Images", icon: "far fa-file-image" },
        { value: "video", label: "Videos", icon: "far fa-file-video" },
      ];
    },
  },
  mounted() {
    this.fetch_drive_items();
    this.drive_id = get_drive_id();
    this.load_local_timestamps();

    // Close dropdowns if clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.dropdown')) {
        this.close_all_dropdowns();
      }
    });
  },
  watch: {
    share_mode() {
      this.share_link = "";
      this.selected_access_level = "";
      this.user_access_level = "";
    }
  },
  methods: {
     _safe_key_re() {
      return /^[A-Za-z0-9_.:~-]+$/;
    },

    _parse_opens_map() {
      let raw = null;
      try {
        raw = JSON.parse(localStorage.getItem('file_opens') || '{}');
      } catch {
        return new Map();
      }
      if (raw === null || typeof raw !== 'object') return new Map();

      const safe = this._safe_key_re();
      const max_future = Date.now() + 365 * 24 * 60 * 60 * 1000;
      const entries = [];

      for (const key of Object.keys(raw)) {
        if (this._is_valid_entry(raw, key, safe, max_future)) {
          const desc = Object.getOwnPropertyDescriptor(raw, key);
          const timestamp = this._extract_timestamp(desc.value);
          if (timestamp !== null) {
            entries.push([key, timestamp]);
          }
        }
      }
      return new Map(entries);
    },

    _is_valid_entry(raw, key, safe_regex, max_future) {
      if (!safe_regex.test(key)) return false;

      const desc = Object.getOwnPropertyDescriptor(raw, key);
      if (!desc || !desc.enumerable) return false;
      const timestamp = this._extract_timestamp(desc.value);
      return timestamp !== null && timestamp <= max_future;
    },

    _extract_timestamp(value) {
      const num = typeof value === 'string' ? value.trim() : String(value || '').trim();
      if (!/^\d{1,13}$/.test(num)) return null;
      const timestamp = Number(num);
      if (!Number.isFinite(timestamp) || timestamp <= 0) return null;
      return timestamp;
    },

    _persist_opens_map(opens_map) {
      const obj = Object.create(null);
      const safe = this._safe_key_re();

      for (const [k, v] of opens_map) {
        const key = String(k);
        if (!safe.test(key)) continue;

        const val = String(v).trim();
        if (!/^\d{1,13}$/.test(val)) continue;

        Object.defineProperty(obj, key, {
          value: val,
          writable: false,
          enumerable: true,
          configurable: false
        });
      }
      localStorage.setItem('file_opens', JSON.stringify(obj));
    },

    _get_open_ts(opens_map, id) {
      if (typeof id !== 'string' || !this._safe_key_re().test(id)) return null;
      return opens_map.get(id) ?? null;
    },

    _set_open_ts(opens_map, id, ts) {
      if (typeof id !== 'string' || !this._safe_key_re().test(id)) return;
      if (typeof ts !== 'number' || !Number.isFinite(ts) || ts <= 0) return;
      opens_map.set(id, ts);
    },

    _get_safe_property(obj, prop, default_value = '') {
      const desc = Object.getOwnPropertyDescriptor(obj, prop);
      if (!desc?.enumerable) return default_value;
      const value = desc.value;
      if (value === undefined || value === null) return default_value;
      if (typeof default_value === 'string') {
        return typeof value === 'string' ? value : String(value);
      }

      if (typeof default_value === 'number') {
        const num = Number(value);
        return Number.isFinite(num) ? num : default_value;
      }

      return value;
    },

    set_active_tab(tab) {
      this.active_tab = tab;
    },
    load_local_timestamps() {
      const opens_map = this._parse_opens_map();

      this.drive_items = this.drive_items.map((item) => {
        const local_ts = this._get_open_ts(opens_map, String(item.id));
        if (typeof local_ts === 'number' && local_ts > Number(item.updated_ts || 0)) {
          return {
            ...item,
            updated_ts: local_ts,
            updated_at: new Date(local_ts).toISOString(),
          };
        }
        return item;
      });
    },

    format_drive_date(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}/${month}/${day}, ${hours}:${minutes}:${seconds}`;
    },

    fetch_drive_items() {
      const url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/aic_drive/get_drive_items/';
      const token = get_token();
      if (!token) {
        this.$router.push({ name: 'Login' });
        return;
      }
      const user_id = localStorage.getItem('user_id');

      const payload = {
        user_id: user_id
      };

      $.ajax({
        url: url,
        method: "GET",
        data: payload,
        headers: {
          "Authorization": `Token ${token}`,
          'X-Page-URL': window.location.href,
        },
        success: (response) => {
          const response_data = typeof response === "string" ? JSON.parse(response) : response;

          if (response_data.status === "success") {
            // Map backend items into frontend format
            let items = response_data.data.map(item => ({
              id: item.id,
              name: item.name,
              owner: item.owner,
              updated_at: item.updated_at, // keep as raw date for sorting
              updated_ts: new Date(item.updated_at).getTime(),
              formatted_date: this.format_drive_date(new Date(item.updated_at)),
              type: item.item_type,
              parent_id: item.parent_folder || "My Drive",
              shared_access_level: item.shared_access_level || null,
            }));

            items.sort((a, b) => {
              if (a.type === b.type) {
                return new Date(b.updated_at) - new Date(a.updated_at); // newest first
              }
              return a.type === "folder" ? -1 : 1; // folders before files
            });

            // Assign formatted date for display
            this.drive_items = items.map(item => ({
              ...item,
              updated_at: item.formatted_date
            }));

            this.apply_local_timestamps();

          } else {
            console.error("Failed to load drive items", response_data.message);
          }
        },
        error: (xhr) => {
          if (xhr.status === 401) {
            this.$router.push({ name: 'Login' });
          } else {
            this.$notyf.error(xhr?.responseJSON.message || `Failed to fetch drive items: HTTP ${xhr.status}`);
          }
        }
      });
    },

    can_download(file) {
      // Owners can always download
      if (!file.shared_access_level) return true;

      return file.shared_access_level.name !== "Viewer";
    },

    can_edit(file) {
      if (!file.shared_access_level) return true;
      return file.shared_access_level.name === "Editor";
    },

    can_share_file(file) {
      // Owner (not shared) → can share
      if (!file.shared_access_level) return true;

      // Viewer → no share
      return file.shared_access_level.name !== 'Viewer';
    },

    navigate_to_folder(folder_name) {
      this.current_folder = folder_name || "My Drive";
    },

    format_relative(ts) {
      if (!ts) return "just now";
      const diff = Date.now() - ts;
      const minutes = Math.round(diff / 60000);
      if (minutes < 1) return "just now";
      if (minutes < 60) return `${minutes} min ago`;
      const hours = Math.round(minutes / 60);
      if (hours < 24) return `${hours} hour${hours > 1 ? "s" : ""} ago`;
      const days = Math.round(hours / 24);
      if (days < 30) return `${days} day${days > 1 ? "s" : ""} ago`;
      const date = new Date(ts);
      return date.toLocaleDateString();
    },

    ext_of(name = "") {
      const dot = name.lastIndexOf(".");
      return dot >= 0 ? name.slice(dot + 1).toLowerCase() : "";
    },

    matches_chip(item, type) {
      if (item.type === "folder") return type === "all";
      const ext = this.ext_of(item.name);

      if (type === "word") {
        return ext === "doc" || ext === "docx";
      } else if (type === "excel") {
        return ext === "xls" || ext === "xlsx" || ext === "csv";
      } else if (type === "ppt") {
        return ext === "ppt" || ext === "pptx";
      } else if (type === "pdf") {
        return ext === "pdf";
      } else if (type === "image") {
        return ["jpg","jpeg","png","gif","bmp","svg","webp"].includes(ext);
      } else if (type === "video") {
        return ["mp4","mov","avi","mkv","flv","wmv","webm", "m4a"].includes(ext);
      } else if (type === "all") {
        return true;
      } else {
        return false;
      }
    },

    file_icon(file, large = false) {
      if (file.type === "folder")
        return large ? "fas fa-folder fa-2x text-warning" : "fas fa-folder text-warning";

      const ext = this.ext_of(file.name);
      let icon;

      switch (ext) {
        case "pdf": icon = "far fa-file-pdf"; break;
        case "doc":
        case "docx": icon = "far fa-file-word"; break;
        case "xls":
        case "xlsx":
        case "csv": icon = "far fa-file-excel"; break;
        case "ppt":
        case "pptx": icon = "far fa-file-powerpoint"; break;
        case "jpg":
        case "jpeg":
        case "png":
        case "gif":
        case "svg":
        case "bmp":
        case "webp": icon = "far fa-file-image"; break;
        case "mp4":
        case "mov":
        case "avi":
        case "mkv":
        case "flv":
        case "wmv":
        case "webm": icon = "far fa-file-video"; break;
        case "mp3":
        case "m4a":
        case "wav": icon = "far fa-file-audio"; break;
        default: icon = "far fa-file"; break;
      }

      return large ? `${icon} fa-2x` : icon;
    },

    track_file_open(file_id) {
      const opens_map = this._parse_opens_map();
      this._set_open_ts(opens_map, String(file_id), Date.now());
      this._persist_opens_map(opens_map);
    },

    apply_local_timestamps() {
      const opens_map = this._parse_opens_map();
      this.drive_items = this.drive_items.map((item) => {

        const id_desc = Object.getOwnPropertyDescriptor(item, 'id');
        if (!id_desc || !id_desc.enumerable) return item;
        const item_id = String(id_desc.value);
        const local_ts = this._get_open_ts(opens_map, item_id);

        if (typeof local_ts === 'number') {
          const updated_at_desc = Object.getOwnPropertyDescriptor(item, 'updated_at');
          const updated_ts_desc = Object.getOwnPropertyDescriptor(item, 'updated_ts');

          const updated_at_val = updated_at_desc && updated_at_desc.enumerable ? updated_at_desc.value : null;
          const updated_ts_val = updated_ts_desc && updated_ts_desc.enumerable ? updated_ts_desc.value : 0;

          const parsed = new Date(updated_at_val).getTime();
          const backend_ts = Number.isFinite(parsed) ? parsed : Number(updated_ts_val || 0);

          if (local_ts > backend_ts) {
            return Object.freeze({
              ...item,
              updated_ts: local_ts,
              updated_at: this.format_drive_date(new Date(local_ts)),
            });
          }
        }
        return item;
      });
    },

    open_item(file) {
      this.close_all_dropdowns();
      if (file.type === "folder") {
        this.navigate_to_folder(file.name);
        return;
      }

      this.track_file_open(file.id);

      const original = this.drive_items.find((item) => item.id === file.id);
      if (original) {
        const now = Date.now();

        const updated = Object.freeze({
          id: this._get_safe_property(original, 'id', ''),
          name: this._get_safe_property(original, 'name', ''),
          owner: this._get_safe_property(original, 'owner', ''),
          type: this._get_safe_property(original, 'type', 'file'),
          parent_id: this._get_safe_property(original, 'parent_id', 'My Drive'),
          updated_ts: now,
          updated_at: new Date(now).toISOString(),
        });

        const file_index = this.drive_items.findIndex((item) => item.id === file.id);
        if (file_index !== -1) {
          if (this.$set) {
            this.$set(this.drive_items, file_index, updated);
          } else {
            this.drive_items.splice(file_index, 1, updated);
          }
        }
      }

      this.preview_file(file);
    },

    handle_continue() {
      if (this.active_tab === 'folder') {
        this.create_folder();
      } else if (this.active_tab === 'upload') {
        this.upload_file();
      } else if (this.active_tab === 'workspace') {
        // handle workspace logic later
      }
    },

    async create_folder() {
      const url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/aic_drive/create_folder/';
      const folder_name = $('#folderName').val().trim();

      if (!folder_name) {
        this.$notyf.info('Please enter a folder name.');
        return;
      }

      const token = get_token();
      if (!token || !this.drive_id) {
       this.$router.push({ name: 'Login' });
      }

      this.uploading_in_progress = true;

      const payload = {
        name: folder_name,
        parent_folder: this.current_folder || "My Drive",
        drive_id: this.drive_id,
        item_type_id: 1
      };

      $.ajax({
        url: url,
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify(payload),
        headers: {
          'Authorization': `Token ${token}`,
          'X-Page-URL': window.location.href,
        },
        success: async (response) => {
          const response_data = typeof response === 'string' ? JSON.parse(response) : response;

          if (response_data.status === "success") {
            this.$notyf.success('Folder created successfully!');
            await this.fetch_drive_items();
          } else {
            this.$notyf.error('Failed to create folder.');
          }
          this.uploading_in_progress = false;
        },
        error: (xhr) => {
          if (xhr.status === 401) {
            this.$router.push({ name: 'Login' });
          } else {
            this.$notyf.error(xhr?.responseJSON.message || `An error occurred while creating folder: HTTP ${xhr.status}`);
          }
          this.uploading_in_progress = false;
        }
      });

      // Clear input field
      $('#folderName').val('');
    },

    trigger_file_input() {
      document.getElementById("drive_file_input").click();
    },

    handle_file_select(event) {
      const files = Array.from(event.target.files);
      this.uploads = files; // store files in Vue state
    },

    handle_drop(event) {
      this.drag_over = false;
      const files = event.dataTransfer.files;
      this.handle_file_select({ target: { files } });
    },

    async upload_file() {
      const url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/aic_drive/upload_file/';

      if (!this.uploads.length) {
        this.$notyf.info('Please select at least one file to upload.');
        return;
      }

      const token = get_token();
      if (!token || !this.drive_id) {
        this.$router.push({ name: 'Login' });
        return;
      }
      this.uploading_in_progress = true;

      const breadcrumb_path = ["My Drive", ...this.breadcrumb_path.map(f => f.name)];
      const breadcrumb_string = breadcrumb_path.join("/");

      const get_file_type_id = (filename) => {
        const ext = filename.split('.').pop().toLowerCase();

        const document_exts = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'csv'];
        const image_exts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'];
        const video_exts = ['mp4', 'mov', 'avi', 'mkv', 'flv', 'wmv', 'webm'];
        const audio_exts = ['mp3', 'wav', 'ogg', 'aac', 'flac', 'm4a'];

        if (document_exts.includes(ext)) return 1;
        if (image_exts.includes(ext)) return 2;
        if (video_exts.includes(ext)) return 3;
        if (audio_exts.includes(ext)) return 4;
        return 1; // default to 'Documents' if unknown
      };

      const upload_single_file = (file) => {
        return new Promise((resolve, reject) => {
          const form_data = new FormData();
          const file_type_id = get_file_type_id(file.name);
          form_data.append("file", file);
          form_data.append("name", file.name);
          form_data.append("parent_folder", this.current_folder || "My Drive");
          form_data.append("drive_id", this.drive_id);
          form_data.append("item_type_id", 2);
          form_data.append("file_type_id", file_type_id);
          form_data.append("size", file.size);
          form_data.append("breadcrumb_path", breadcrumb_string);

          $.ajax({
            url: url,
            method: "POST",
            data: form_data,
            processData: false,
            contentType: false,
            headers: {
              'Authorization': `Token ${token}`,
              'X-Page-URL': window.location.href,
            },
            success: (response) => {
              const response_data = typeof response === 'string' ? JSON.parse(response) : response;
              if (response_data.status === "success") {
                const display_name = file.name.length > 30
                  ? file.name.substring(0, 15) + "..." + file.name.slice(-10)
                  : file.name;
                this.$notyf.success(`Uploaded: ${display_name}`);
                resolve(response_data);
              } else {
                const msg = response_data?.message || `Failed to upload ${file.name}`;
                this.$notyf.error(msg);
                reject(response_data);
              }
              this.uploading_in_progress = false;
            },
            error: (xhr) => {
              if (xhr.status === 403) {
                const error_data = xhr.responseJSON;
                const msg = error_data?.message || `You don't have permission to upload ${file.name}`;
                this.$notyf.error(msg);
              } else if (xhr.status === 401) {
                this.$router.push({ name: 'Login' });
              } else {
                this.$notyf.error(`Error uploading ${file.name}: HTTP ${xhr.status}`);
              }
              this.uploading_in_progress = false;
              reject(xhr);
            }
          });
        });
      };

      try {
        await Promise.all(this.uploads.map(file => upload_single_file(file)));
        this.uploads = [];
        $('#drive_file_input').val('');
        await this.fetch_drive_items();
      } catch (e) {
        this.$notyf.error('Some files failed to upload.');
      }
    },

    toggle_dropdown(file_id) {
      this.open_dropdown_id = this.open_dropdown_id === file_id ? null : file_id;
      this.submenu_open = {}; // reset submenus when switching dropdowns
    },

    toggle_menu(file_id, menu_name) {
      if (this.open_submenu_id === file_id && this.open_menu_name === menu_name) {
        // close it if already open
        this.open_submenu_id = null;
        this.open_menu_name = null;
      } else {
        // open the clicked submenu
        this.open_submenu_id = file_id;
        this.open_menu_name = menu_name;
      }
    },

    share_to_user(file) {
      // open modal or API call
      this.share_file = file;
      this.share_user_modal = true;

      this.share_link = "";
      this.selected_access_level = "";
      this.user_access_level = "";

      this.reset_share_user_state();
      this.fetch_available_users();
      this.fetch_user_access_levels();
      this.close_all_dropdowns();
    },

    reset_share_user_state() {
      this.selected_share_users = [];
      this.user_search_query = '';
      this.filtered_available_users = [];
      this.available_users = [];
      this.loading_users = false;
      this.users_error = null;
      this.sharing_in_progress = false;
      this.share_success = false;
      this.share_error = null;
      this.user_access_level = '';
      this.selected_access_level = '';
      this.share_link = '';
    },

    close_share_user_modal() {
      this.share_user_modal = false;
      this.reset_share_user_state();
      this.share_file = null
    },

    fetch_available_users() {
      const url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/aic_drive/get_available_users/';
      const token = get_token();

      if (!token) {
        this.$router.push({ name: 'Login' });
        return;
      }

      this.loading_users = true;
      this.users_error = null;

      $.ajax({
        url: url,
        method: "GET",
        headers: {
          "Authorization": `Token ${token}`,
          'X-Page-URL': window.location.href,
        },
        success: (response) => {
          const response_data = typeof response === "string" ? JSON.parse(response) : response;

          if (response_data.status === "success") {
            this.available_users = response_data.data.map(user => ({
              id: user.id,
              name: user.name || user.full_name || `${user.first_name} ${user.last_name}`.trim() || user.email,
              email: user.email,
              role: user.role_name || user.role || 'User'
            }));
            
            this.filtered_available_users = [...this.available_users];
          } else {
            this.users_error = response_data.message || "Failed to load users";
          }
          
          this.loading_users = false;
        },
        error: (xhr, status, error) => {
          console.error("Error fetching users:", xhr.responseText || error);
          this.users_error = "An error occurred while fetching users. Please try again.";
          this.loading_users = false;
        }
      });
    },

    fetch_user_access_levels() {
      const token = get_token();
      if (!token) {
        this.$router.push({ name: 'Login' });
        return;
      }

      const url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/aic_drive/list_link_access_levels/';
      $.ajax({
        url,
        method: "GET",
        headers: { "Authorization": `Token ${token}` },
        success: (response) => {
          const arr = Array.isArray(response) ? response : (response?.data || []);
          this.access_levels = arr;
          // Default to 'Edit' access level
          const edit_level = this.access_levels.find(level =>
            level.name.toLowerCase().includes('edit') || level.name.toLowerCase().includes('editor')
          );
          if (edit_level) {
            this.user_access_level = edit_level.id;
          }
        },
        error: (xhr) => {
          let err_msg = "Failed to load access levels."; // default message
          try {
            const response = JSON.parse(xhr.responseText);
            if (response && response.message) {
              err_msg = response.message;
            }
          } catch (e) {
            console.error("Failed to parse error response:", e);
          }
          console.error("Error fetching access levels:", xhr.responseText || err_msg);
          this.$notyf.error(err_msg);
        }
      });
    },

    filter_users() {
      const query = this.user_search_query.toLowerCase().trim();
      if (!query) {
        this.filtered_available_users = [...this.available_users];
        return;
      }
      
      this.filtered_available_users = this.available_users.filter(user =>
        user.name.toLowerCase().includes(query) ||
        user.email.toLowerCase().includes(query)
      );
    },

    toggle_user_selection(user) {
      const index = this.selected_share_users.findIndex(u => u.id === user.id);
      if (index > -1) {
        this.selected_share_users.splice(index, 1);
      } else {
        this.selected_share_users.push(user);
      }
    },

    is_user_selected(user_id) {
      return this.selected_share_users.some(u => u.id === user_id);
    },

    handle_share_with_users() {
      if (this.selected_share_users.length === 0) {
        this.$notyf.info('Please select at least one user to share with.');
        return;
      }

      if (!this.user_access_level) {
        this.$notyf.info('Please select an access level.');
        return;
      }

      const url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/aic_drive/share_with_users/';
      const token = get_token();

      if (!token) {
        this.$router.push({ name: 'Login' });
        return;
      }

      this.sharing_in_progress = true;
      this.share_error = null;

      const payload = {
        drive_item_id: this.share_file.id,
        recipient_ids: this.selected_share_users.map(u => u.id),
        access_level: this.user_access_level
      };

      $.ajax({
        url: url,
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify(payload),
        headers: {
          'Authorization': `Token ${token}`,
          'X-Page-URL': window.location.href,
        },
        success: (response) => {
          const response_data = typeof response === 'string' ? JSON.parse(response) : response;
          
          if (response_data.status === "success") {
            this.share_success = true;
            const userCount = this.selected_share_users.length;
            const userNames = this.selected_share_users.map(u => u.name).join(', ');
            
            this.$notyf.success(
              `File "${this.share_file.name}" shared successfully with ${userCount} user(s): ${userNames}`
            );
            
            setTimeout(() => {
              this.close_share_user_modal();
            }, 2500);
          } else {
            this.share_error = response_data.message || 'Failed to share file. Please try again.';
            this.$notyf.error(this.share_error);
          }
          
          this.sharing_in_progress = false;
        },
        error: (xhr, status, error) => {
          console.error("Error sharing file:", xhr.responseText || error);
          
          let errorMessage = "An error occurred while sharing the file.";
          try {
            const errorData = JSON.parse(xhr.responseText);
            errorMessage = errorData.message || errorMessage;
          } catch (e) {
            // Use default message
          }
          
          this.share_error = errorMessage;
          this.$notyf.error(this.share_error);
          this.sharing_in_progress = false;
        }
      });
    },

    close_all_dropdowns() {
      this.open_dropdown_id = null;
      this.open_submenu_id = null;
      this.open_menu_name = null;
    },

    share_via_link(file) {
      const token = get_token();
      if (!token) {
        this.$router.push({ name: 'Login' });
        return;
      }

      // Save file currently being shared
      this.share_file = file;
      this.share_link = "";            // reset old link
      this.selected_access_level = ""; // reset previous selection

      // Fetch access levels
      const url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/aic_drive/list_link_access_levels/';
      $.ajax({
        url: url,
        method: "GET",
        headers: {
          "Authorization": `Token ${token}`,
        },
        success: (response) => {
          this.access_levels = response;
          this.share_modal = true;
        },
        error: (xhr, status, error) => {
          console.error("Error fetching access levels:", xhr.responseText || error);
          this.$notyf.error( xhr.responseText || " test Failed to load access levels.");
        }
      });
    },

    generate_share_link() {
      if (!this.selected_access_level) {
        this.$notyf.info("Please select an access level.");
        return;
      }

      const url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/aic_drive/assign_share_link_access/';
      const token = get_token();
      const user_id = localStorage.getItem('user_id');

      const payload = {
        user_id: user_id,
        link_access_level_id: this.selected_access_level,
        drive_item_id: this.share_file.id
      };

      $.ajax({
        url: url,
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify(payload),
        headers: {
          "Authorization": `Token ${token}`,
          'X-Page-URL': window.location.href,
        },
        success: (response) => {
          const response_data = typeof response === "string" ? JSON.parse(response) : response;

          if (response_data.status === "success") {
            this.share_link = response_data.data.share_url;
            this.$notyf.success("Share link generated!");
          } else {
            this.$notyf.error("Failed to generate share link.");
          }
        },
        error: (xhr, status, error) => {
          console.error("Error generating share link:", xhr.responseText || error);
          this.$notyf.error("An error occurred while generating share link.");
        }
      });
    },

    copy_share_link() {
      navigator.clipboard.writeText(this.share_link)
      .then(() => {
        this.$notyf.success("Link copied to clipboard!");
      })
      .catch(() => {
        this.$notyf.error("Failed to copy link.");
      });
    },

    close_share_modal() {
      this.share_modal = false;
      this.share_link = "";
    },

    download_file() {
      // API call for download
    },

    archive_file() {
      // API call for archive
    },

    preview_file(file) {
      this.close_all_dropdowns()
      const token = get_token();
      if (!token) {
        this.$router.push({ name: 'Login' });
        return;
      }

      const url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/aic_drive/preview_file/';

      $.ajax({
        url: url,
        method: "GET",
        data: { drive_item_id: file.id },
        headers: {
          "Authorization": `Token ${token}`,
        },
        success: (response) => {
          const response_data = typeof response === "string" ? JSON.parse(response) : response;

          if (response_data.status === "success") {
            const { file_name, file_url } = response_data.data;

            this.preview_file_name = file_name;
            this.preview_file_url = file_url
            this.preview_file_access_level = file.shared_access_level || null;
            this.preview_modal = true
          } else {
            this.$notyf.error("Failed to load file preview.");
          }
        },
        error: (xhr, status, error) => {
          console.error("Error previewing file:", xhr.responseText || error);
          this.$notyf.error("An error occurred while previewing the file.");
        }
      });
    },

    close_the_file_preview(){
      this.preview_modal = false
      this.preview_file_url = null
    },

    // Drag and drop handlers
    handle_drag_start(event, file) {
      // Only allow dragging files, not folders (or allow folders too if you want)
      this.dragged_item = file;
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/html', event.target);

      // Add dragging class
      event.target.classList.add('dragging');
    },

    handle_drag_end(event) {
      event.target.classList.remove('dragging');
      this.dragged_item = null;
      this.drag_over_folder_id = null;
    },

    handle_drag_over(event, folder) {
      // Only allow drop on folders
      if (folder.type !== 'folder') return;

      event.preventDefault();
      event.dataTransfer.dropEffect = 'move';

      this.drag_over_folder_id = folder.id;
    },

    handle_drag_leave(folder) {
      if (folder.type !== 'folder') return;
      this.drag_over_folder_id = null;
    },

    handle_drop_on_folder(event, target_folder) {
      event.preventDefault();
      event.stopPropagation();
      this.drag_over_folder_id = null;

      if (!this.dragged_item) return;

      // 1. Validation: Prevent dropping any item onto itself
      if (this.dragged_item.id === target_folder.id) {
        return;
      }

      // 2. Validation: Prevent dropping a folder into a file
      if (target_folder.type !== 'folder') {
        return;
      }

      // 3. Validation: Specifically for folders - prevent dropping into itself
      if (this.dragged_item.type === 'folder' && target_folder.name === this.dragged_item.name) {
        this.$notyf.error("You cannot move a folder into itself.");
        return;
      }

      // Proceed with move
      this.move_item_to_folder(this.dragged_item, target_folder);
    },

    move_item_to_folder(item, target_folder) {
      const url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/aic_drive/move_item/';
      const token = get_token();

      const payload = {
        item_id: item.id,
        target_folder_id: target_folder.id,
        target_folder_name: target_folder.name
      };

      $.ajax({
        url: url,
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify(payload),
        headers: {
          'Authorization': `Token ${token}`,
          'X-Page-URL': window.location.href,
        },
        success: () => {
          this.$notyf.success(`Moved to ${target_folder.name}`);

          const item_index = this.drive_items.findIndex(i => i.id === item.id);

          if (item_index !== -1) {
            const current_item = Reflect.get(this.drive_items, item_index);
            const updated_item = Object.assign({}, current_item);
            Reflect.set(updated_item, 'parent_id', target_folder.name);
            this.drive_items.splice(item_index, 1, updated_item);
          }
        },
        error: () => {
            this.$notyf.error("Failed to move item.");
        }
      });
    },

    // Inside methods:
    handle_drop_on_path(event, target_folder) {
      event.preventDefault();
      event.stopPropagation();
      this.drag_over_folder_id = null;

      if (!this.dragged_item) return;

      // 1. Check if the target is the root
      if (target_folder === null) {
        this.$notyf.info("Moving files to the default 'My Drive' folder is not allowed. Please select a specific folder.");
        return; // Stop the execution here
      }

      const target_name = target_folder.name;
      const target_id = target_folder.id;

      // 2. Standard check: Don't move if it's already in the target folder
      if (this.dragged_item.parent_id === target_name) {
        return;
      }

      // 3. Proceed with move if it's a subfolder
      this.move_item_to_folder(this.dragged_item, {
        id: target_id,
        name: target_name
      });
    },

    handle_drop_on_root() {
      // Check if there is an item currently being dragged
      if (!this.dragged_item) return;

      // Create a mock target for the root directory
      const root_target = {
        id: null, // or your specific root ID if applicable
        name: "My Drive"
      };

      // Reuse your existing move logic
      this.move_item_to_folder(this.dragged_item, root_target);
    },

    // Libre Office Online integration
    can_open_in_office(file) {
      // Only files, not folders
      if (!file || file.type === "folder") return false;

      // Must be editable (owner OR shared as Editor)
      if (!this.can_edit(file)) return false;

      // Only office formats you actually want to send to Collabora/WOPI
      const ext = this.ext_of(file.name);
      const supported = [
        "doc", "docx", "odt",
        "xls", "xlsx", "ods",
        "ppt", "pptx", "odp",
        "txt", "csv"
      ];

      return supported.includes(ext);
    },

    open_in_office(file) {
      const token = get_token();
      if (!token) {
        this.$router.push({ name: "Login" });
        return;
      }

      this.close_all_dropdowns();

      const url = process.env.VUE_APP_API_BASE_URL + "/aic_one_api/aic_drive/api/open_in_editor_api/";

      $.ajax({
        url: url,
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify({ drive_item_id: file.id }),
        headers: {
          "Authorization": `Token ${token}`,
          "X-Page-URL": window.location.href,
        },
        success: (response) => {
          const res = typeof response === "string" ? JSON.parse(response) : response;
          const editor_url = res?.editor_url || res?.data?.editor_url;

          if (!editor_url) {
            this.$notyf.error("Editor URL was not returned by server.");
            return;
          }

          this.track_file_open(file.id);
          window.open(editor_url, "_blank", "noopener,noreferrer");

          // When user comes back to this tab, refresh list to reflect new version
          this._refresh_after_editor_return();
        },
        error: (xhr) => {
          if (xhr.status === 403) {
            this.$notyf.error("You do not have edit permission for this file.");
            return;
          }
          if (xhr.status === 401) {
            this.$router.push({ name: "Login" });
            return;
          }
          this.$notyf.error(xhr?.responseJSON?.message || `Failed to open editor: HTTP ${xhr.status}`);
        },
      });
    },

    _refresh_after_editor_return() {
      if (this._office_focus_handler) {
        window.removeEventListener("focus", this._office_focus_handler);
      }

      // Refresh once when user returns to this browser tab
      this._office_focus_handler = async () => {
        window.removeEventListener("focus", this._office_focus_handler);
        this._office_focus_handler = null;

        await this.fetch_drive_items();
        this.apply_local_timestamps();
      };

      window.addEventListener("focus", this._office_focus_handler);
    },
  }
};